export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-redevelopment-3.679e77ce.jpg";